export default {
    mode: import.meta.env.VITE_ENV || import.meta.env.NODE_ENV,
    certhApiKey: import.meta.env.VITE_CERTH_TOKEN || '',
    immanApiKey: import.meta.env.VITE_IMMAN_TOKEN || '',
    certhLotusApiKey: import.meta.env.VITE_CERTH_LOTUS_TOKEN || '',
    atc_api_base_url: import.meta.env.VITE_ATC_API_BASE_URL || '',
    truly_cbs: import.meta.env.VITE_TRULY_CBS || '',
    truly_token: import.meta.env.VITE_TRULY_TOKEN || '',
    gaide_base_url: import.meta.env.VITE_GAIDE_BASE_URL || '',
    gaide_client_id: import.meta.env.VITE_GAIDE_CLIENT_ID || '',
    gaide_client_secret: import.meta.env.VITE_GAIDE_CLIENT_SECRET || '',
    keycloak_realm: import.meta.env.VITE_KEYCLOAK_REALM || '',
    keycloak_url: import.meta.env.VITE_KEYCLOAK_URL || '',
    keycloak_clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || ''
};
